import template from './authentication.html';

class ProfileAuthenticationTabComponentVM
{
	constructor(params)
	{
		this.vm = params.vm;
		this.UserProfileDialogs = ko.observableArray(window.UserAccountDialogs || []);
		this.UserProfilePages = ko.observableArray(window.UserAccountPages || []);
		this.availableAuthenticationServers = ko.observableArray();
		this.availableAuthenticationMethods = ko.observableArray(['local', 'remote']);
		this.auth_service = ko.observable();
		this.auth_service_uuid = ko.observable(null);
		this.auth_mech = ko.observable('local');
		this.new_password = ko.observable('');
		this.active = ko.observable(true);
		this.pending = ko.observable(false);
		this.uuid = ko.observable('');
		this.otp_methods = ko.observableArray([]);
		this.api_keys = ko.observableArray([]);
		this.delegatee_username = ko.observable();
		this.delegator_username = ko.observable();
		this.delegation_code = ko.observable();
		this.delegation_expiry_date = ko.observable();

		this.vm.register_tab_state('authentication', this);
		this.vm.user_data.subscribe((user) => {
			this.load_from_user(user);
		});

		if (this.vm.user_data())
			this.load_from_user(this.vm.user_data());

		this.init();

		this.vm.selected_tab.subscribe((selectedTab) => {
			if (selectedTab == 'authentication')
				this.load_api_keys();
		});

		this.uuid.subscribe(() => {
			if (this.vm.selected_tab() == 'authentication')
				this.load_api_keys();
		});
	}

	load_from_user (user)
	{
		if (!user)
			return;
		this.active(user.active);
		this.pending(user.pending || false);
		this.uuid(user.uuid || '');
		this.otp_methods(user.settings?.otp_methods || []);
		const auth_info = user.auth_info || {};
		this.auth_mech(auth_info.auth_mech || 'local');
		this.auth_service_uuid(auth_info.auth_params?.uuid || null);
		this.auth_service(null);

		if (this.auth_service_uuid())
		{
			const authServer = this.availableAuthenticationServers().find((server) => server.service_uuid == this.auth_service_uuid());
			if (authServer)
				this.auth_service(authServer);
		}
	}

	async init ()
	{
		const auth_services_res = await Grape.fetches.getJSON('/api/auth-services');
		this.availableAuthenticationServers(auth_services_res.services || []);

		if (this.auth_service_uuid())
		{
			const authServer = this.availableAuthenticationServers().find((server) => server.service_uuid == this.auth_service_uuid());
			if (authServer)
				this.auth_service(authServer);
		}

		if (this.vm.selected_tab() == 'authentication')
			await this.load_api_keys();
	}

	async load_api_keys ()
	{
		if (!this.uuid())
		{
			this.api_keys([]);
			return;
		}

		const data = await Grape.fetches.getJSON('/api/record', {
			table: 'v_api_keys_config',
			schema: 'users',
			filter: [{
				field: 'user_uuid',
				operator: '=',
				value: this.uuid()
			}]
		});

		const records = [];
		for (let r of (data.records || []))
		{
			records.push({
				name: r.name,
				roles: r.attributes?.roles || [],
				description: r.attributes?.description,
				date_inserted: r.date_inserted,
				last_used: r.last_used,
				uuid: r.api_key_uuid
			});
		}
		this.api_keys(records);
	}

	async detele_api_key_click (apikey)
	{
		if (!(await Grape.alerts.confirm({ type: 'warning', title: 'Delete API Key', message: 'Are you sure?' })))
			return;

		try {
			const result = await Grape.fetches.deleteJSON(`/api/apikey/${apikey.uuid}`, {});
			if (result?.status == 'ERROR')
				throw new Error('Failed to delete API key');

			Grape.alerts.alert({ type: 'success', title: 'Success', message: 'API key has been deleted' });
		} catch (err) {
			Grape.alerts.alert({ type: 'error', title: 'Error', message: err.message });
		} finally {
			await this.load_api_keys();
		}
	}

	async btnUserAccountDialog_click (item)
	{
		await Grape.dialog.open(item.dialog_name, {});
	}

	btnUserProfilePage_click (item)
	{
		window.Grape.navigate(item.navigate_url);
	}

	async btnGrantUserAccess_click ()
	{
		try {
			const result = await Grape.fetches.postJSON('api/user/delegate', {
				delegatee: this.delegatee_username(),
				expiry_date: this.delegation_expiry_date()
			});

			if (result.status == 'ERROR')
				throw new Error(result.message || result.code);

			Grape.alerts.alert({
				type: 'success',
				title: `Granted access to ${this.delegatee_username()}!`,
				message: `Save the following access code to login to ${this.delegatee_username()}: \n${result.access_code}`
			});
		} catch (error) {
			Grape.alerts.alert({ type: 'error', title: 'Error', message: error.message });
		}
	}

	async btnLoginAsDelegatee_click ()
	{
		try {
			const result = await Grape.fetches.postJSON('/api/session/switch-user', {
				delegation_code: this.delegation_code(),
				username: this.delegator_username()
			});

			if (result.status == 'ERROR')
				throw new Error(result.message || result.code);

			window.location.reload();
		} catch (error) {
			Grape.alerts.alert({ type: 'error', title: 'Error', message: error.message });
		}
	}

	get_save_data ()
	{
		const payload = {
			active: this.active(),
			pending: this.pending(),
			uuid: this.uuid(),
			auth_mech: this.auth_mech(),
			password: null,
			otp_methods: this.otp_methods()
		};

		if (this.auth_service())
		{
			payload.auth_service_params = {
				name: this.auth_service().service_name,
				uuid: this.auth_service().service_uuid
			};
		}

		if (this.new_password() != '')
			payload.password = this.new_password();

		return payload;
	}

	reset_after_save ()
	{
		this.new_password('');
	}
}

export default {
	name: 'profile-authentication-tab',
	viewModel: ProfileAuthenticationTabComponentVM,
	module_type: 'ko',
	template: template
};
